/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Sorting happens entirely in your browser; nothing is uploaded.`)
};

const es_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La clasificación ocurre completamente en tu navegador; nada se carga.`)
};

const de_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Das Sortieren erfolgt vollständig in Ihrem Browser; es wird nichts hochgeladen.`)
};

const nl_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Sortering gebeurt volledig in uw browser; niets wordt geüpload.`)
};

const fr_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le tri se déroule entièrement dans votre navigateur ; rien n'est téléchargé.`)
};

const it_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. L'ordinamento avviene interamente nel tuo browser; nulla viene caricato.`)
};

const pt_br2_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A ordenação ocorre inteiramente no seu navegador; nada é enviado.`)
};

const pt_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A classificação acontece inteiramente no seu navegador; nada é enviado.`)
};

const ja_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。ソートはブラウザ内で完全に実行されます。何もアップロードされません。`)
};

const zh_ls_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。排序完全在你的浏览器中进行；不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_faq3_a", locale)
	if (locale === "en") return en_ls_faq3_a(inputs)
	if (locale === "es") return es_ls_faq3_a(inputs)
	if (locale === "de") return de_ls_faq3_a(inputs)
	if (locale === "nl") return nl_ls_faq3_a(inputs)
	if (locale === "fr") return fr_ls_faq3_a(inputs)
	if (locale === "it") return it_ls_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ls_faq3_a(inputs)
	if (locale === "pt") return pt_ls_faq3_a(inputs)
	if (locale === "ja") return ja_ls_faq3_a(inputs)
	return zh_ls_faq3_a(inputs)
};